export default __webpack_public_path__ + "static/media/shareIcon.338f4684.svg";